export const NOTIFICATIONS_TRANSLATION_NAMESPACE = "notifications";

export const NOTIFICATIONS_TK = "NOTIFICATIONS_TK";
